import TitleMain from "../../Title/TitleMain";
import {Link, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowAltCircleUp,
    faCalendarAlt,
    faCalendarCheck, faCalendarDay, faCalendarXmark,
    faChair, faDumbbell,
    faEdit,
    faExternalLink, faLocation, faLocationDot,
    faSquareCheck, faTools,
    faTrash,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleIcon} from "../../../services/UserService";
import {ImageIllustration} from "../../Image/ImageIllustration";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import SearchCoach from "../../Search/SearchCoach";
import Loader from "../../Loader/Loader";

const ActiviteVue = ({}) => {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [data, setData] = useState();
    const [activite, setActivite] = useState();
    const [entreprise, setEntreprise] = useState();
    const [contrat, setContrat] = useState();
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const {entrepriseId, contratId, activiteId} = useParams();
    const [coach, setCoach] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const editCoach = () => {
        let selectedCoach = coach;

        showModal('classic', {
            children:
                <div style={{width: "600px", height: "auto", padding: "60px"}}>
                    <div className={styles.formBloc}>
                        <h3>Coach </h3>
                        <SearchCoach onSubmit={(e) => {
                            selectedCoach = e;
                            setCoach(e);
                        }} act={coach}
                        />
                        <p style={{
                            fontStyle: "italic",
                            fontSize: "var(--fs-secondary)",
                            margin: "4px",
                        }}>{coach ?
                            <span style={{color: "var(--clr-success)"}}>{coach}</span> :
                            <span style={{color: "var(--clr-danger)"}}>{activite?.coach?.email}</span>
                        }</p>

                        <button className={`btn`} type="button" onClick={(e) => {
                            handleSubmitCoach(selectedCoach);
                        }}
                                disabled={false}>
                            Enregistrer
                        </button>
                    </div>
                </div>
        });
    }

    const handleSubmitCoach = async (coachToSubmit) => {
        const finalCoach = coachToSubmit || coach;

        if (!finalCoach || !activiteId) {
            handleError("Veuillez sélectionner un coach");
            return;
        }

        try {
            const response = await AxiosConfig.post(`/admin/activites/${activiteId}/change-coach`, finalCoach);
            if (response.data.success) {
                handleSuccess(response.data.message);
            } else {
                handleError(response.data.message);
            }
        } catch (error) {
            console.error(error);
            handleError(error.message);
        }

        setTimeout(
            () => {
                window.location.reload();
            },
            1100
        );
    }

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const putActifOpenModalOld = (row) => {
        const text = data.actif ? "Supprimer" : "Restaurer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette activité ?`,
            onConfirm: async () => {
                setIsLoading(true);
                return;

                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/actif`, {actif: !activite.actif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            await getActivite()
                        }, 500);
                    }
                    handleSuccess("Mis à jour effectuée avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                } finally {
                    setIsLoading(false);
                }
            }
        });
    }

    const putActifOpenModal = () => {
        const text = activite.actif ? "supprimer" : "restaurer";
        showModal('classic', {
            children: (
                <ConfirmActifModal
                    text={text}
                    activite={activite}
                    entreprise={entreprise}
                    contrat={contrat}
                    onClose={hideModal}
                    getActivite={getActivite}
                    handleSuccess={handleSuccess}
                    handleError={handleError}
                />
            )
        });
    };

    const handleSeancesGenerate = async () => {
        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/regenerer_seances`);
            handleSuccess("Séances générées avec succès");
        } catch (error) {
            console.error('error', error);
            handleError("Une erreur est survenue");
        }
    }

    const genererSeances = () => {
        showModal('confirm', {
            message: "Voulez-vous vraiment générer les séances ?",
            onConfirm: () => {
                handleSeancesGenerate();
            }
        });
    }

    const handleSeancesDelete = async () => {
        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/supprimer_seances_safe`);
            handleSuccess("Séances supprimées avec succès");
        } catch (error) {
            console.error('error', error);
            handleError("Une erreur est survenue");
        }
    }

    const supprimerSeances = () => {
        showModal('confirm', {
            message: "Supprimer les séances ? (les séances ayant une absence de coach ou une participation enregistrée ne seront pas supprimées)",
            onConfirm: () => {
                handleSeancesDelete();
            }
        });
    }

    const handleSeancesDeleteAll = async () => {
        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/supprimer_seances`);
            handleSuccess("Séances supprimées avec succès");
        } catch (error) {
            console.error('error', error);
            handleError("Une erreur est survenue");
        }
    }

    const supprimerSeancesAll = () => {
        showModal('confirm', {
            message: "Supprimer les séances ? (même celles ayant une absence de coach ou une participation enregistrée)",
            onConfirm: () => {
                handleSeancesDeleteAll();
            }
        });
    }

    const getActivite = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}`);

            setContrat(response.data.myContrat);
            setEntreprise(response.data.myEntreprise);
            setActivite(response.data.myActivite);
            setData(response.data.myActivite);
        } catch (error) {
            console.error('error', error);
        }
    }

    useEffect(() => {
        getActivite();
    }, []);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({entreprise, contrat, activite}));
    }, [entreprise, contrat]);

    return (
        <>
            {data && !data?.actif && <span style={{
                backgroundColor: "#ec4747",
                color: "#fff",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding:"6px 14px"
            }}>ACTIVITÉ SUPPRIMÉE</span>}

            <TitleMain text={data && data.type && data.type.nom ? data.type.nom : "Chargement ... "}/>
            <div className={styles.containerColumns}>
                <div className={styles.viewBloc}>
                    <div className={styles.headerBtnsVue}>
                        {data && (data?.actif === true || data?.actif === false) &&
                            <button onClick={putActifOpenModal} disabled={isLoading}>
                                {
                                    data && data?.actif ?
                                        <><FontAwesomeIcon icon={faXmark}/>Supprimer</>
                                        : <><FontAwesomeIcon icon={faSquareCheck}/>Restaurer</>
                                }
                            </button>
                        }
                        <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                    </div>

                    <div>
                        <ImageIllustration src={data?.type.image} alt={data?.type.nom} openImage={true}/>
                        <p style={{margin: "16px 0"}}>{data?.type.description}</p>
                    </div>

                    <p>
                        {getUtilisateurRoleIcon("ROLE_COACH")}
                        {data?.coach?.id &&
                            <Link to={Routing.generate({
                                route: Routing.routes.adminUtilisateur,
                                params: {utilisateurId: data?.coach?.id}
                            })}>
                                {data?.coach.prenom} {data?.coach.nom}
                            </Link>
                        }
                    </p>

                    {data?.periode_inscription &&
                        <p>
                            <FontAwesomeIcon icon={faCalendarCheck}/><span style={{marginLeft: "4px"}}>Début des inscriptions :</span>
                            <span
                                style={{marginLeft: "4px"}}> {data?.periode_inscription === -1 ? "dès la publication" : data?.periode_inscription + " jours avant"}</span>
                        </p>
                    }

                    <p>
                        <FontAwesomeIcon icon={faChair}/> {data?.places_max} places max par séance
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faCalendarAlt}/> Début le {DateService.formatDate(data?.date_start)}
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faCalendarXmark}/> Fin le {DateService.formatDate(data?.date_end)}
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faCalendarDay}/>
                        {data?.nb_seances === 0 ? " Pas de séances" : " " + data?.nb_seances + " séances"}
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faLocationDot}/>
                        {data?.lieu?.nom &&
                            " " + data?.lieu.nom + " | " + data?.lieu.adresse + ", " + data?.lieu.ville + " - " + data?.lieu.code_postal
                        }
                    </p>

                    {data?.materiel && data?.materiel.length > 0 &&
                        <p>
                            <FontAwesomeIcon icon={faDumbbell}/><strong> Matériel : </strong>{data.materiel}
                        </p>
                    }
                </div>

                <div className={styles.navLink}>
                    <Link to={Routing.generate({
                        route: Routing.routes.adminSeances,
                        params: {entrepriseId, contratId, activiteId}
                    })}>
                        <FontAwesomeIcon icon={faExternalLink}/>
                        Voir les séances
                    </Link>

                    {data?.type?.id &&
                        <Link to={Routing.generate({
                            route: Routing.routes.adminActiviteType,
                            params: {activiteTypeId: data?.type?.id}
                        })}>
                            <FontAwesomeIcon icon={faExternalLink}/>
                            Voir le type "{data?.type?.nom}"
                        </Link>
                    }

                    <button className={"btn"} onClick={genererSeances}>
                        <FontAwesomeIcon icon={faArrowAltCircleUp}/>
                        Regénérer les séances à venir
                    </button>

                    <button className={"btn"} style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        maxWidth: "200px",
                        fontSize: "0.8em"
                    }} onClick={supprimerSeances}>
                        <FontAwesomeIcon icon={faTrash}/>
                        Supprimer les séances à venir <strong>(sans absences ni participations)</strong>
                    </button>

                    <button className={"btn"} style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        maxWidth: "200px",
                        fontSize: "0.8em"
                    }} onClick={supprimerSeancesAll}>
                        <FontAwesomeIcon icon={faTrash}/>
                        Supprimer les séances à venir <strong>(y compris les absences et participations)</strong>
                    </button>

                    <button className={"btn"} style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        maxWidth: "200px",
                        fontSize: "0.8em"
                    }} onClick={editCoach}>
                        <FontAwesomeIcon icon={faEdit}/>
                        Modifier le coach pour les séances à venir
                    </button>
                </div>
            </div>
        </>
    )
}

export default ActiviteVue;

const ConfirmActifModal = ({ text, activite, entreprise, contrat, onClose, getActivite, handleSuccess, handleError }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            const response = await AxiosConfig.post(
                `/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/actif`,
                { actif: !activite.actif }
            );
            if (response.data.success) {
                setTimeout(async () => await getActivite(), 500);
            }
            handleSuccess("Mise à jour effectuée avec succès");
            onClose();
        } catch (error) {
            console.error('error', error);
            handleError();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h3 className="titleAlert">Voulez-vous vraiment {text} cette activité ?</h3>
            <div style={{ display: "flex", justifyContent: "center", gap: "16px", margin: "12px 0 0 0" }}>
                <button onClick={onClose} className="btn btn_primary">Annuler</button>
                <button onClick={handleConfirm} disabled={isLoading} className={`btn ${!isLoading && "btn_main"}`}>
                    {isLoading ? "Traitement..." : "Confirmer"}
                </button>
            </div>
        </div>
    );
};